import testsParser from './testsParser';
import { LessonsType, LessonsDataType } from './types';

const mapTests = (data: LessonsType): LessonsDataType => data.map(testsParser);

export default mapTests;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/mapTests.ts